import React from 'react';
import {Room} from '@/components';
import {inject, observer} from 'mobx-react';
import {BaseStoreTypes} from '@/stores/base';
import {useEffectOnce} from 'react-use';
import { roomTypes } from '@/types/APITypes';
import useReactRouter from 'use-react-router';

interface SiteProps {
    BaseStore: BaseStoreTypes;
}

const Site: React.FC<SiteProps> =  inject('BaseStore')(observer(props => {
  
    const { RoomStore } = props.BaseStore;
  
    const {history} = useReactRouter();
  
    /* 选择站点 */
    const handleCartOnClick = async (roomData: roomTypes) => {
    
        const status= await RoomStore.checkRoomStatus(roomData.id);
    
        if (!status) return
    
        history.push('/Home/CloudPhone')
    
    }
  
    useEffectOnce(() => {
        (async () => {
            await RoomStore.getRoomList()
        })()
    })
  
    return (
    <>
     <Room.Head/>
     <Room.List onClick={handleCartOnClick} dataSource={RoomStore.roomList} />
    </>
    )
  
}))

export default Site;
